import { ICDAuxCheckboxModel } from "./icd-aux-checkbox.model";
import { ICDBaseModel } from "./icd-base.model";

export class ICDAutocompleteModel extends ICDBaseModel {
  public auxModel: ICDAuxCheckboxModel = null;
  private _value: string;
  public label: string;

  constructor(value?: any, _label?: string) {
    super();
    this._value = value != null ? value : null;
    this.label = _label != null ? _label : null;
  }

  public get value(): string {
    return this._value;
  }
  public set value(value: string) {
    this._value = value;
  }
}
